import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { colors } from '../lib/colors';
import { Col } from '../lib/utils';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import {
    SignInPage,
    SignUpPage,
    MyPage,
    DashBoardPage,
    DailySchedulePage,
    WeeklySchedulePage,
    ScheduleHistoryPage,
    TrainerManagePage,
    TrainerInformationPage,
    SubscriptionPlanPage,
    SuccessSubscriptionPage,
    FailSubscriptionPlanPage,
    SubscriptionPlanChangePage,
    ExpiredPlanPage,
    SuccessChangePayInformation,
    SuccessPurchaseAtExpired,
    FailPurchaseAtExpired,
    FailChangePayInformation,
    CommunicationPage,
    FeedPage,
    FeedMemberPage,
    SchedulePage,
    CreateSchedulePage,
    UpdateSchedulePage,
    NoticePage,
} from './index';
import PrivateRoutes from '../lib/PrivateRoutes';
import SuperAdminPrivateRoutes from '../lib/SuperAdminPrivateRoutes';
import { useRecoilState } from 'recoil';
import { screenHeightState, screenWidthState } from '../atoms/atom';
import ClassPassPage from './ClassPass/ClassPassPage';
import MemberlistPage from './MemberlistPage';
import MemberMembershipManagePage from '../components/MemberProfile/MemberMembershipManagePage';
import MemberTemporaryPage from './MemberTemporaryPage';
import SettlementPage from './Schedule/SettlementPage';
import SettlementPasswordPage from './Settlement/SettlementPasswordPage';
import FeedCenterStatisticsPage from './Feed/FeedCenterStatisticsPage';
import OpsBriefingRouteGuard from './OpsBriefing/OpsBriefingRouteGuard';
import OpsBriefingLayout from './OpsBriefing/OpsBriefingLayout';
import OpsBriefingTodayPage from './OpsBriefing/OpsBriefingTodayPage';
import OpsBriefingMembersPage from './OpsBriefing/OpsBriefingMembersPage';
import OpsBriefingCoachesPage from './OpsBriefing/OpsBriefingCoachesPage';
import OpsBriefingHistoryPage from './OpsBriefing/OpsBriefingHistoryPage';
import FeedMemberSatisfactionPage from './Feed/FeedMemberSatisfactionPage';
import FeedCoachStatisticsPage from './Feed/FeedCoachStatisticsPage';
import { CenterReportLayout } from './Feed/CenterReportLayout';
import { PayrollAuthGuard } from '../components/PayrollAuthGuard';
import FeedInstructorReviewsPage from './Reivew/FeedInstructorReviewsPage';
import CenterMemberReviewsPage from './Reivew/CenterMemberReviewsPage';
import BusinessAdminPage from './BusinessAdmin/BusinessAdminPage';
import InputPaymentPage from './InputPayment/InputPaymentPage';
import InputPaymentSuccessPage from './InputPayment/InputPaymentSuccessPage';
import InputPaymentFailPage from './InputPayment/InputPaymentFailPage';
import FacilityProductPage from './FacilityProduct/FacilityProductPage';
import SubscriptionListPage from './FacilitySubscription/SubscriptionListPage';
import CheckinDashboardPage from './Checkin/CheckinDashboardPage';
import CheckinHistoryPage from './Checkin/CheckinHistoryPage';
import KioskSettingsPage from './Kiosk/KioskSettingsPage';
import TrainerPromoSettingsPage from './Kiosk/TrainerPromoSettingsPage';
import LockerManagementPage from './LockerManagement/LockerManagementPage';
import PublicMemberDetailPage from './PublicMember/PublicMemberDetailPage';
import CenterStatsPage from './CenterStats/CenterStatsPage';
import GroupSettingsPage from './GroupSettings/GroupSettingsPage';
import GroupSchedulePage from './GroupSchedule/GroupSchedulePage';
import NewOpportunityPage from './NewOpportunity/NewOpportunityPage';
import GroupTicketPage from './GroupTicket/GroupTicketPage';
import GroupMembershipPage from './GroupMembership/GroupMembershipPage';
import GroupSettlementPage from './Settlement/GroupSettlementPage';
import MemberPaymentPage from './MemberPayment/MemberPaymentPage';
import MemberPaymentCheckoutPage from './MemberPayment/MemberPaymentCheckoutPage';
import MemberPaymentCardRegPage from './MemberPayment/MemberPaymentCardRegPage';
import MockPGPage from './MemberPayment/MockPGPage';
import MemberPaymentCompletePage from './MemberPayment/MemberPaymentCompletePage';
import MemberPaymentFailPage from './MemberPayment/MemberPaymentFailPage';
import GiftPayTrainerPage from './GiftPay/GiftPayTrainerPage';
import GiftPayMemberPage from './GiftPay/GiftPayMemberPage';
import GiftPayCompletePage from './GiftPay/GiftPayCompletePage';
import GiftPayFailPage from './GiftPay/GiftPayFailPage';
import RappoPayPage from './RappoPay/RappoPayPage';
import RappoSuperAdminDashboard from './SuperAdmin/RappoSuperAdminDashboard';
import TeamListPage from './Team/TeamListPage';
import TeamDetailPage from './Team/TeamDetailPage';
import CenterViewBootstrap from '../components/CenterView/CenterViewBootstrap';
import GifticonGiftPage from './Gifticon/GifticonGiftPage';

const RouteGroup = ({
    createAlert,
    onClickTerm,
    createTwoButtonAlert,
    setIsLoading,
    onClickAddTrainer,
    authObject,
    setAuthObject,
    authorization,
    scrollToTop,
}: any) => {
    const [screenWidth, setScreenWidth] = useRecoilState(screenWidthState);
    const [screenHeight, setScreenHeight] = useRecoilState(screenHeightState);
    const location = useLocation();

    return (
        <Col
            style={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                // backgroundColor: location.pathname.includes('sign') ? colors.WHITE_50 : colors.WHITE_200,
                backgroundColor: '#F4F5F7',
            }}
        >
            <Col style={{ width: '100vw', backgroundColor: colors.white }}>
                <Routes>
                    <Route
                        path="/"
                        element={
                            authorization && authObject ? (
                                <Navigate to={authObject.role === 'superadmin' ? '/superadmin' : '/dash'} replace />
                            ) : (
                                <SignInPage createAlert={createAlert} />
                            )
                        }
                    />
                    <Route path="/signIn" element={<SignInPage createAlert={createAlert} />} />
                    <Route path="/center-view" element={<CenterViewBootstrap />} />
                    <Route
                        path="/signUp"
                        element={<SignUpPage createAlert={createAlert} onClickTerm={onClickTerm} />}
                    />

                    {/* 공개 카드 등록 페이지 (비로그인 접근 가능) */}
                    <Route path="/input-payment/:adminId" element={<InputPaymentPage />} />
                    <Route path="/input-payment/:adminId/success" element={<InputPaymentSuccessPage />} />
                    <Route path="/input-payment/:adminId/fail" element={<InputPaymentFailPage />} />

                    {/* 회원 수강권 결제 (비로그인 공개) */}
                    <Route path="/pay/:paymentRequestId" element={<MemberPaymentPage />} />
                    <Route path="/pay/:paymentRequestId/checkout" element={<MemberPaymentCheckoutPage />} />
                    <Route path="/pay/:paymentRequestId/card-register" element={<MemberPaymentCardRegPage />} />
                    <Route path="/pay/:paymentRequestId/mock-pg" element={<MockPGPage />} />
                    <Route path="/pay/complete" element={<MemberPaymentCompletePage />} />
                    <Route path="/pay/fail" element={<MemberPaymentFailPage />} />

                    {/* 기프티콘 선물 결제 모바일 웹 (비로그인 공개) */}
                    <Route path="/gift-pay/trainer/:orderId" element={<GiftPayTrainerPage />} />
                    <Route path="/gift-pay/member/:orderId" element={<GiftPayMemberPage />} />
                    <Route path="/gift-pay/:orderId/complete" element={<GiftPayCompletePage />} />
                    <Route path="/gift-pay/:orderId/fail" element={<GiftPayFailPage />} />

                    {/* 카드 등록 셀프서비스 페이지 (비로그인 접근 가능) */}
                    <Route path="/setup-payment" element={<BusinessAdminPage />} />

                    {/* 슈퍼어드민 대시보드 — teams 포함 모든 sub-path를 RappoSuperAdminDashboard가 처리 */}
                    <Route path="/superadmin/*" element={<SuperAdminPrivateRoutes />}>
                        <Route path="*" element={<RappoSuperAdminDashboard />} />
                    </Route>

                    <Route element={<PrivateRoutes />}>
                        {/* 대시보드 페이지 */}
                        <Route path="/dash" element={<DashBoardPage createAlert={createAlert} />} />
                        {/*
                          * 운영 리포트 — 데일리 브리핑.
                          *
                          * 가드를 두 겹 건다. **순서가 중요하다.**
                          *
                          *   ① OpsBriefingRouteGuard — 이 센터에 기능이 열려 있나 (노출 게이트).
                          *      로그인만으로는 부족하다. 메뉴를 숨겨도 주소를 직접 치면 열린다.
                          *      fail-closed: 판정 전에는 열지 않고, 조회에 실패해도 닫는다.
                          *   ② PayrollAuthGuard — 2차 비밀번호 (탭 잠금 설정).
                          *
                          * 노출 게이트가 **바깥**이다. 기능이 닫힌 센터에서 비밀번호부터 물으면
                          * 없는 기능의 존재를 알려 주는 꼴이 된다. /gifticon 은 노출 게이트가
                          * 없어 PayrollAuthGuard 하나만 걸려 있는데, 그 자리와 같은 위치다.
                          *
                          * 이 탭의 잠금 기본값은 **잠금**이다 (lockedSections.ts).
                          * 회원 개인 데이터가 통째로 실리고, 이 안에서 선물(포인트)이 나간다.
                          */}
                        <Route element={<OpsBriefingRouteGuard />}>
                            <Route
                                path="/opsBriefing"
                                element={
                                    <PayrollAuthGuard>
                                        <OpsBriefingLayout />
                                    </PayrollAuthGuard>
                                }
                            >
                                <Route path="today" element={<OpsBriefingTodayPage />} />
                                <Route path="members" element={<OpsBriefingMembersPage />} />
                                <Route path="coaches" element={<OpsBriefingCoachesPage />} />
                                <Route path="history" element={<OpsBriefingHistoryPage />} />
                            </Route>
                        </Route>
                        {/* 스케줄 페이지 */}
                        <Route
                            path="/schedule"
                            element={
                                <PayrollAuthGuard>
                                    <SchedulePage
                                        createAlert={createAlert}
                                        createTwoButtonAlert={createTwoButtonAlert}
                                        setIsLoading={setIsLoading}
                                    />
                                </PayrollAuthGuard>
                            }
                        />

                        <Route
                            path="/schedule/history"
                            element={
                                <PayrollAuthGuard>
                                    <ScheduleHistoryPage createAlert={createAlert} setIsLoading={setIsLoading} />
                                </PayrollAuthGuard>
                            }
                        />

                        <Route
                            path="/schedule/create"
                            element={
                                <PayrollAuthGuard>
                                    <CreateSchedulePage createAlert={createAlert} setIsLoading={setIsLoading} />
                                </PayrollAuthGuard>
                            }
                        />

                        <Route
                            path="/schedule/update"
                            element={
                                <PayrollAuthGuard>
                                    <UpdateSchedulePage createAlert={createAlert} setIsLoading={setIsLoading} />
                                </PayrollAuthGuard>
                            }
                        />

                        <Route
                            path="/settlement"
                            element={
                                <PayrollAuthGuard>
                                    <SettlementPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />

                        {/* 라포페이 */}
                        <Route path="/rappopay" element={<RappoPayPage />} />

                        {/* PT팀 관리 */}
                        <Route path="/teams" element={<TeamListPage createAlert={createAlert} />} />
                        <Route path="/teams/:teamId" element={<TeamDetailPage createAlert={createAlert} />} />

                        {/* 스케줄 관리 탭 */}
                        {/* <Route
                            path="/schedule/daily"
                            element={
                                <DailySchedulePage
                                    createAlert={createAlert}
                                    createTwoButtonAlert={createTwoButtonAlert}
                                    setIsLoading={setIsLoading}
                                />
                            }
                        />
                        <Route
                            path="/schedule/weekly"
                            element={<WeeklySchedulePage createAlert={createAlert} setIsLoading={setIsLoading} />}
                        />
                       */}

                        {/* 강사 관리 탭 */}
                        <Route
                            path="/trainerManage"
                            element={
                                <PayrollAuthGuard>
                                    <TrainerManagePage
                                        createAlert={createAlert}
                                        onClickAddTrainer={onClickAddTrainer}
                                        setIsLoading={setIsLoading}
                                    />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route
                            path="/trainerManage/trainerInfo"
                            element={
                                <PayrollAuthGuard>
                                    <TrainerInformationPage
                                        createAlert={createAlert}
                                        onClickAddTrainer={onClickAddTrainer}
                                    />
                                </PayrollAuthGuard>
                            }
                        />
                        {/* 회원 리스트 탭 */}
                        <Route
                            path="/memberList"
                            element={
                                <PayrollAuthGuard>
                                    <MemberlistPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        {/*
                          🔴 구 회원 프로필(`/member/detail` · `MemberProfilePage`)을 지웠다
                             (2026-09-02). 현행은 아래 「통합 회원 상세」
                             `/member/:memberId`(`PublicMemberDetailPage`)이고,
                             회원 목록의 행 클릭도 그쪽으로 간다.

                          라우터에 둘 다 살아 있어서 구별이 안 됐고, 실제로 오늘의
                          시그널 카드가 구 화면으로 링크돼 「예전 화면이 뜬다」는
                          지적이 나왔다. 경로 정의는 이제 `lib/memberRoutes` 한 곳뿐이다.

                          ⚠️ `/member/detail/membership`(수강권 상세)은 **다른 화면이고
                             살아 있다.** 통합 회원 상세가 그리로 보낸다.
                        */}
                        {/* 임시회원 등록 화면 */}
                        <Route
                            path="/member/temporary"
                            element={
                                <PayrollAuthGuard>
                                    <MemberTemporaryPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        {/* 회원 프로필 -> 회원 수강권 상세 */}
                        <Route
                            path="/member/detail/membership"
                            element={
                                <PayrollAuthGuard>
                                    <MemberMembershipManagePage
                                        createAlert={createAlert}
                                        createTwoButtonAlert={createTwoButtonAlert}
                                    />
                                </PayrollAuthGuard>
                            }
                        />
                        {/* 회원 소통 상자 탭 */}
                        <Route
                            path="/member/communication"
                            element={
                                <PayrollAuthGuard>
                                    <CommunicationPage
                                        createTwoButtonAlert={createTwoButtonAlert}
                                        createAlert={createAlert}
                                        authObject={authObject}
                                        setAuthObject={setAuthObject}
                                    />
                                </PayrollAuthGuard>
                            }
                        />

                        {/* 수업 피드 탭 */}

                        <Route
                            path="/feed"
                            element={
                                <PayrollAuthGuard>
                                    <FeedPage
                                        authObject={authObject}
                                        setAuthObject={setAuthObject}
                                        authorization={authorization}
                                        setIsLoading={setIsLoading}
                                    />
                                </PayrollAuthGuard>
                            }
                        />

                        {/* 공지사항 */}
                        <Route
                            path="/notice"
                            element={
                                <PayrollAuthGuard>
                                    <NoticePage />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route
                            path="/gifticon"
                            element={
                                <PayrollAuthGuard>
                                    <GifticonGiftPage />
                                </PayrollAuthGuard>
                            }
                        />

                        {/* 센터 운영 */}
                        <Route path="/publicMember" element={<Navigate to="/memberList" replace />} />
                        <Route path="/publicMember/register" element={<Navigate to="/member/temporary" replace />} />
                        {/* 기존 /publicMember/:memberId 하위 호환 — 동적 파라미터를 포워딩 */}
                        <Route
                            path="/publicMember/:memberId"
                            element={
                                <PayrollAuthGuard>
                                    <PublicMemberDetailPage
                                        createAlert={createAlert}
                                        createTwoButtonAlert={createTwoButtonAlert}
                                    />
                                </PayrollAuthGuard>
                            }
                        />
                        {/* 통합 회원 상세 */}
                        <Route
                            path="/member/:memberId"
                            element={
                                <PayrollAuthGuard>
                                    <PublicMemberDetailPage
                                        createAlert={createAlert}
                                        createTwoButtonAlert={createTwoButtonAlert}
                                    />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route
                            path="/facilityProduct"
                            element={
                                <PayrollAuthGuard>
                                    <FacilityProductPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route
                            path="/facilitySubscription"
                            element={
                                <PayrollAuthGuard>
                                    <SubscriptionListPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route path="/facilitySales" element={<Navigate to="/facilitySubscription" replace />} />
                        <Route
                            path="/checkin"
                            element={
                                <PayrollAuthGuard>
                                    <CheckinDashboardPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route
                            path="/checkin/history"
                            element={
                                <PayrollAuthGuard>
                                    <CheckinHistoryPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route
                            path="/kioskSettings"
                            element={
                                <PayrollAuthGuard>
                                    <KioskSettingsPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route
                            path="/tabletPromotion"
                            element={
                                <PayrollAuthGuard>
                                    <TrainerPromoSettingsPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route
                            path="/kioskSettings/trainer-promo"
                            element={<Navigate to="/tabletPromotion" replace />}
                        />
                        <Route
                            path="/locker"
                            element={
                                <PayrollAuthGuard>
                                    <LockerManagementPage
                                        createAlert={createAlert}
                                        createTwoButtonAlert={createTwoButtonAlert}
                                    />
                                </PayrollAuthGuard>
                            }
                        />
                        <Route
                            path="/centerStats"
                            element={
                                <PayrollAuthGuard>
                                    <CenterStatsPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        {/* 그룹 수업 */}
                        <Route path="/group/schedule" element={<GroupSchedulePage createAlert={createAlert} />} />
                        <Route path="/group/tickets" element={<GroupTicketPage createAlert={createAlert} />} />
                        <Route path="/group/memberships" element={<GroupMembershipPage createAlert={createAlert} />} />
                        <Route path="/group/settings" element={<GroupSettingsPage createAlert={createAlert} />} />
                        <Route
                            path="/group/settlement"
                            element={
                                <PayrollAuthGuard>
                                    <GroupSettlementPage createAlert={createAlert} />
                                </PayrollAuthGuard>
                            }
                        />
                        {/* 하위 호환 리다이렉트 */}
                        <Route
                            path="/groupClasses"
                            element={<Navigate to="/classPass?tab=group&sub=classes" replace />}
                        />
                        <Route
                            path="/group/classes"
                            element={<Navigate to="/classPass?tab=group&sub=classes" replace />}
                        />
                        <Route path="/groupSettings" element={<Navigate to="/group/settings" replace />} />
                        <Route path="/groupSettlement" element={<Navigate to="/group/settlement" replace />} />

                        <Route
                            path="/centerReport"
                            element={
                                <PayrollAuthGuard>
                                    <CenterReportLayout />
                                </PayrollAuthGuard>
                            }
                        >
                            <Route path="centerStatistics" element={<FeedCenterStatisticsPage />} />
                            <Route
                                path="instructorReviews"
                                element={<FeedInstructorReviewsPage onClickAddTrainer={onClickAddTrainer} />}
                            />
                            <Route path="memberReviews" element={<CenterMemberReviewsPage />} />
                            <Route
                                path="newOpportunities"
                                element={<NewOpportunityPage createAlert={createAlert} embedded />}
                            />

                            <Route path="memberSatisfaction" element={<FeedMemberSatisfactionPage />} />
                            <Route path=":coachId" element={<FeedCoachStatisticsPage />} />
                        </Route>

                        <Route
                            path="/feed/member"
                            element={
                                <PayrollAuthGuard>
                                    <FeedMemberPage
                                        authObject={authObject}
                                        setAuthObject={setAuthObject}
                                        authorization={authorization}
                                        setIsLoading={setIsLoading}
                                    />
                                </PayrollAuthGuard>
                            }
                        />

                        {/* 수강권 관리 탭 */}
                        <Route
                            path="/classPass"
                            element={
                                <PayrollAuthGuard>
                                    <ClassPassPage
                                        authObject={authObject}
                                        setAuthObject={setAuthObject}
                                        authorization={authorization}
                                        createAlert={createAlert}
                                    />
                                </PayrollAuthGuard>
                            }
                        />

                        {/* 마이페이지 탭 */}
                        <Route
                            path="/myPage"
                            element={
                                <MyPage
                                    createAlert={createAlert}
                                    authObject={authObject}
                                    setAuthObject={setAuthObject}
                                />
                            }
                        />
                        {/* 무료 플랜중 구독플랜 구입 페이지 */}
                        <Route
                            path="/myPage/SubscriptionPlanPage"
                            element={
                                <SubscriptionPlanPage
                                    createAlert={createAlert}
                                    createTwoButtonAlert={createTwoButtonAlert}
                                />
                            }
                        />
                        <Route
                            path="/myPage/SubscriptionPlanPage/success"
                            element={<SuccessSubscriptionPage createAlert={createAlert} onClickTerm={onClickTerm} />}
                        />
                        <Route path="/myPage/SubscriptionPlanPage/fail" element={<FailSubscriptionPlanPage />} />

                        {/* 유료구독 기간중 구독플랜 변경 페이지 */}
                        <Route
                            path="/myPage/SubscriptionPlanChangePage"
                            element={
                                <SubscriptionPlanChangePage
                                    createAlert={createAlert}
                                    onClickTerm={onClickTerm}
                                    scrollToTop={scrollToTop}
                                    createTwoButtonAlert={createTwoButtonAlert}
                                />
                            }
                        />
                        <Route
                            path="/myPage/changePayInfo/success"
                            element={<SuccessChangePayInformation createAlert={createAlert} />}
                        />
                        <Route
                            path="/myPage/changePayInfo/fail"
                            element={<FailChangePayInformation createAlert={createAlert} />}
                        />

                        <Route
                            path="/expired"
                            element={<ExpiredPlanPage createAlert={createAlert} onClickTerm={onClickTerm} />}
                        />
                        <Route
                            path="/expired/success"
                            element={<SuccessPurchaseAtExpired createAlert={createAlert} onClickTerm={onClickTerm} />}
                        />
                        <Route path="/expired/fail" element={<FailPurchaseAtExpired />} />
                    </Route>
                </Routes>
                {/* </Col> */}
                {/* {authorization && <Bottom />} */}
            </Col>
        </Col>
    );
};

export default RouteGroup;
